// Client-side mirror of config/countries.yml. Each entry includes:
//   id        - internal numeric Country.id
//   label     - display name
//   isoCode   - ISO 3166-1 alpha-2 (id 0 = "Other", id 11 = legacy "UK" rather than "GB")
//   isEu      - EU membership
//   availableInPickers - whether the country is exposed in customer-facing dropdowns.
//               the YAML field is `supported`, which doesn't actually describe what
//               the boolean controls. Renamed here for readability at use sites — when
//               you change one source, also change the other.
//   pinIndex  - mirrors `pin_index` in countries.yml; only present on countries that
//               should appear pinned at the top of pickers (lower index = higher up).
//
// Option B (not done now): server-bootstrap this list from Country.ordered_for_select
// (render JSON in the layout or expose an endpoint) so countries.yml is the single
// source of truth and data drift can't happen (yml currently has ~10 entries that
// aren't in this file). Would require updating every consumer of `countries` /
// `isEuCountry` and verifying first-paint timing in code-split bundles — skipped
// for now in favor of additive enrichment.
export const countries = [
  { id: 0, label: 'Other', isoCode: 'Other', isEu: false, availableInPickers: true, pinIndex: 0 },
  { id: 1, label: 'United States', isoCode: 'US', isEu: false, availableInPickers: true, pinIndex: 1 },
  { id: 229, label: 'Afghanistan', isoCode: 'AF', isEu: false, availableInPickers: false }, // OFAC-sanctioned
  { id: 230, label: 'Albania', isoCode: 'AL', isEu: false, availableInPickers: true },
  { id: 231, label: 'Algeria', isoCode: 'DZ', isEu: false, availableInPickers: true },
  { id: 40, label: 'American Samoa', isoCode: 'AS', isEu: false, availableInPickers: false },
  { id: 39, label: '\u00c5land Islands', isoCode: 'AX', isEu: false, availableInPickers: false },
  { id: 232, label: 'Andorra', isoCode: 'AD', isEu: false, availableInPickers: true },
  { id: 226, label: 'Anguilla', isoCode: 'AI', isEu: false, availableInPickers: true },
  { id: 41, label: 'Antarctica', isoCode: 'AQ', isEu: false, availableInPickers: false },
  { id: 227, label: 'Antigua and Barbuda', isoCode: 'AG', isEu: false, availableInPickers: true },
  { id: 228, label: 'Argentina', isoCode: 'AR', isEu: false, availableInPickers: true },
  { id: 233, label: 'Armenia', isoCode: 'AM', isEu: false, availableInPickers: true },
  { id: 219, label: 'Aruba', isoCode: 'AW', isEu: false, availableInPickers: true },
  { id: 6, label: 'Australia', isoCode: 'AU', isEu: false, availableInPickers: true },
  { id: 23, label: 'Austria', isoCode: 'AT', isEu: true, availableInPickers: true },
  { id: 234, label: 'Azerbaijan', isoCode: 'AZ', isEu: false, availableInPickers: true },
  { id: 2, label: 'Bahamas', isoCode: 'BS', isEu: false, availableInPickers: true },
  { id: 235, label: 'Bahrain', isoCode: 'BH', isEu: false, availableInPickers: true },
  { id: 236, label: 'Bangladesh', isoCode: 'BD', isEu: false, availableInPickers: true },
  { id: 220, label: 'Barbados', isoCode: 'BB', isEu: false, availableInPickers: true },
  { id: 237, label: 'Belarus', isoCode: 'BY', isEu: false, availableInPickers: false }, // OFAC-sanctioned
  { id: 29, label: 'Belgium', isoCode: 'BE', isEu: true, availableInPickers: false },
  { id: 221, label: 'Belize', isoCode: 'BZ', isEu: false, availableInPickers: true },
  { id: 238, label: 'Benin', isoCode: 'BJ', isEu: false, availableInPickers: true },
  { id: 239, label: 'Bhutan', isoCode: 'BT', isEu: false, availableInPickers: true },
  { id: 240, label: 'Bolivia (Plurinational State of)', isoCode: 'BO', isEu: false, availableInPickers: true },
  { id: 42, label: 'Bonaire\n Sint Eustatius\n Saba', isoCode: 'BQ', isEu: false, availableInPickers: true },
  { id: 241, label: 'Bosnia and Herzegovina', isoCode: 'BA', isEu: false, availableInPickers: true },
  { id: 242, label: 'Botswana', isoCode: 'BW', isEu: false, availableInPickers: true },
  { id: 43, label: 'Bouvet Island', isoCode: 'BV', isEu: false, availableInPickers: false },
  { id: 243, label: 'Brazil', isoCode: 'BR', isEu: false, availableInPickers: true },
  { id: 44, label: 'British Indian Ocean Territory (the)', isoCode: 'IO', isEu: false, availableInPickers: false },
  { id: 244, label: 'Brunei Darussalam', isoCode: 'BN', isEu: false, availableInPickers: true },
  { id: 17, label: 'Bulgaria', isoCode: 'BG', isEu: true, availableInPickers: true },
  { id: 245, label: 'Burkina Faso', isoCode: 'BF', isEu: false, availableInPickers: true },
  { id: 246, label: 'Burundi', isoCode: 'BI', isEu: false, availableInPickers: true },
  { id: 247, label: 'Cabo Verde', isoCode: 'CV', isEu: false, availableInPickers: true },
  { id: 248, label: 'Cambodia', isoCode: 'KH', isEu: false, availableInPickers: true },
  { id: 249, label: 'Cameroon', isoCode: 'CM', isEu: false, availableInPickers: true },
  { id: 3, label: 'Canada', isoCode: 'CA', isEu: false, availableInPickers: true, pinIndex: 2 },
  { id: 225, label: 'Cayman Islands (the)', isoCode: 'KY', isEu: false, availableInPickers: true },
  { id: 250, label: 'Central African Republic (the)', isoCode: 'CF', isEu: false, availableInPickers: true },
  { id: 251, label: 'Chad', isoCode: 'TD', isEu: false, availableInPickers: true },
  { id: 222, label: 'Chile', isoCode: 'CL', isEu: false, availableInPickers: true },
  { id: 37, label: 'China', isoCode: 'CN', isEu: false, availableInPickers: true },
  { id: 45, label: 'Christmas Island', isoCode: 'CX', isEu: false, availableInPickers: false },
  { id: 46, label: 'Cocos (Keeling) Islands (the)', isoCode: 'CC', isEu: false, availableInPickers: false },
  { id: 47, label: 'Colombia', isoCode: 'CO', isEu: false, availableInPickers: true },
  { id: 48, label: 'Comoros (the)', isoCode: 'KM', isEu: false, availableInPickers: false },
  { id: 49, label: 'Congo (the Democratic Republic of the)', isoCode: 'CD', isEu: false, availableInPickers: false },
  { id: 50, label: 'Congo (the)', isoCode: 'CG', isEu: false, availableInPickers: false },
  { id: 51, label: 'Cook Islands (the)', isoCode: 'CK', isEu: false, availableInPickers: false },
  { id: 52, label: 'Costa Rica', isoCode: 'CR', isEu: false, availableInPickers: false },
  { id: 19, label: 'Croatia', isoCode: 'HR', isEu: true, availableInPickers: true },
  { id: 54, label: 'Cuba', isoCode: 'CU', isEu: false, availableInPickers: false },
  { id: 55, label: 'Cura\u00e7ao', isoCode: 'CW', isEu: false, availableInPickers: true },
  { id: 28, label: 'Cyprus', isoCode: 'CY', isEu: true, availableInPickers: false },
  { id: 21, label: 'Czech Republic', isoCode: 'CZ', isEu: true, availableInPickers: true },
  { id: 53, label: 'C\u00f4te d\'Ivoire', isoCode: 'CI', isEu: false, availableInPickers: false },
  { id: 27, label: 'Denmark', isoCode: 'DK', isEu: true, availableInPickers: false },
  { id: 56, label: 'Djibouti', isoCode: 'DJ', isEu: false, availableInPickers: false },
  { id: 57, label: 'Dominica', isoCode: 'DM', isEu: false, availableInPickers: true },
  { id: 58, label: 'Dominican Republic (the)', isoCode: 'DO', isEu: false, availableInPickers: true },
  { id: 59, label: 'Ecuador', isoCode: 'EC', isEu: false, availableInPickers: false },
  { id: 60, label: 'Egypt', isoCode: 'EG', isEu: false, availableInPickers: false },
  { id: 61, label: 'El Salvador', isoCode: 'SV', isEu: false, availableInPickers: false },
  { id: 62, label: 'Equatorial Guinea', isoCode: 'GQ', isEu: false, availableInPickers: false },
  { id: 63, label: 'Eritrea', isoCode: 'ER', isEu: false, availableInPickers: false },
  { id: 34, label: 'Estonia', isoCode: 'EE', isEu: true, availableInPickers: false },
  { id: 64, label: 'Eswatini', isoCode: 'SZ', isEu: false, availableInPickers: false },
  { id: 65, label: 'Ethiopia', isoCode: 'ET', isEu: false, availableInPickers: false },
  { id: 66, label: 'Falkland Islands (the) [Malvinas]', isoCode: 'FK', isEu: false, availableInPickers: false },
  { id: 67, label: 'Faroe Islands (the)', isoCode: 'FO', isEu: false, availableInPickers: false },
  { id: 68, label: 'Fiji', isoCode: 'FJ', isEu: false, availableInPickers: false },
  { id: 25, label: 'Finland', isoCode: 'FI', isEu: true, availableInPickers: false },
  { id: 8, label: 'France', isoCode: 'FR', isEu: true, availableInPickers: true },
  { id: 69, label: 'French Guiana', isoCode: 'GF', isEu: false, availableInPickers: false },
  { id: 70, label: 'French Polynesia', isoCode: 'PF', isEu: false, availableInPickers: false },
  { id: 71, label: 'French Southern Territories (the)', isoCode: 'TF', isEu: false, availableInPickers: false },
  { id: 72, label: 'Gabon', isoCode: 'GA', isEu: false, availableInPickers: false },
  { id: 73, label: 'Gambia (the)', isoCode: 'GM', isEu: false, availableInPickers: false },
  { id: 74, label: 'Georgia', isoCode: 'GE', isEu: false, availableInPickers: true },
  { id: 12, label: 'Germany', isoCode: 'DE', isEu: true, availableInPickers: true },
  { id: 75, label: 'Ghana', isoCode: 'GH', isEu: false, availableInPickers: false },
  { id: 76, label: 'Gibraltar', isoCode: 'GI', isEu: false, availableInPickers: false },
  { id: 36, label: 'Great Britain', isoCode: 'GB', isEu: true, availableInPickers: false },
  { id: 18, label: 'Greece', isoCode: 'GR', isEu: true, availableInPickers: true },
  { id: 77, label: 'Greenland', isoCode: 'GL', isEu: false, availableInPickers: false },
  { id: 78, label: 'Grenada', isoCode: 'GD', isEu: false, availableInPickers: true },
  { id: 79, label: 'Guadeloupe', isoCode: 'GP', isEu: false, availableInPickers: true },
  { id: 80, label: 'Guam', isoCode: 'GU', isEu: false, availableInPickers: false },
  { id: 81, label: 'Guatemala', isoCode: 'GT', isEu: false, availableInPickers: false },
  { id: 82, label: 'Guernsey', isoCode: 'GG', isEu: false, availableInPickers: false },
  { id: 83, label: 'Guinea', isoCode: 'GN', isEu: false, availableInPickers: false },
  { id: 84, label: 'Guinea-Bissau', isoCode: 'GW', isEu: false, availableInPickers: false },
  { id: 85, label: 'Guyana', isoCode: 'GY', isEu: false, availableInPickers: false },
  { id: 86, label: 'Haiti', isoCode: 'HT', isEu: false, availableInPickers: false },
  { id: 87, label: 'Heard Island and McDonald Islands', isoCode: 'HM', isEu: false, availableInPickers: false },
  { id: 88, label: 'Holy See (the)', isoCode: 'VA', isEu: false, availableInPickers: false },
  { id: 89, label: 'Honduras', isoCode: 'HN', isEu: false, availableInPickers: false },
  { id: 90, label: 'Hong Kong', isoCode: 'HK', isEu: false, availableInPickers: false },
  { id: 24, label: 'Hungary', isoCode: 'HU', isEu: true, availableInPickers: true },
  { id: 91, label: 'Iceland', isoCode: 'IS', isEu: false, availableInPickers: false },
  { id: 92, label: 'India', isoCode: 'IN', isEu: false, availableInPickers: false },
  { id: 93, label: 'Indonesia', isoCode: 'ID', isEu: false, availableInPickers: false },
  { id: 94, label: 'Iran (Islamic Republic of)', isoCode: 'IR', isEu: false, availableInPickers: false },
  { id: 95, label: 'Iraq', isoCode: 'IQ', isEu: false, availableInPickers: false },
  { id: 22, label: 'Ireland', isoCode: 'IE', isEu: true, availableInPickers: true },
  { id: 96, label: 'Isle of Man', isoCode: 'IM', isEu: false, availableInPickers: false },
  { id: 97, label: 'Israel', isoCode: 'IL', isEu: false, availableInPickers: false },
  { id: 13, label: 'Italy', isoCode: 'IT', isEu: true, availableInPickers: true },
  { id: 98, label: 'Jamaica', isoCode: 'JM', isEu: false, availableInPickers: true },
  { id: 38, label: 'Japan', isoCode: 'JP', isEu: false, availableInPickers: false },
  { id: 99, label: 'Jersey', isoCode: 'JE', isEu: false, availableInPickers: false },
  { id: 100, label: 'Jordan', isoCode: 'JO', isEu: false, availableInPickers: false },
  { id: 101, label: 'Kazakhstan', isoCode: 'KZ', isEu: false, availableInPickers: false },
  { id: 102, label: 'Kenya', isoCode: 'KE', isEu: false, availableInPickers: false },
  { id: 103, label: 'Kiribati', isoCode: 'KI', isEu: false, availableInPickers: false },
  {
    id: 104,
    label: 'Korea (the Democratic People\'s Republic of)',
    isoCode: 'KP',
    isEu: false,
    availableInPickers: false
  },
  { id: 105, label: 'Korea (the Republic of)', isoCode: 'KR', isEu: false, availableInPickers: false },
  { id: 106, label: 'Kuwait', isoCode: 'KW', isEu: false, availableInPickers: false },
  { id: 107, label: 'Kyrgyzstan', isoCode: 'KG', isEu: false, availableInPickers: false },
  { id: 108, label: 'Lao People\'s Democratic Republic (the)', isoCode: 'LA', isEu: false, availableInPickers: false },
  { id: 35, label: 'Latvia', isoCode: 'LV', isEu: true, availableInPickers: false },
  { id: 109, label: 'Lebanon', isoCode: 'LB', isEu: false, availableInPickers: false },
  { id: 110, label: 'Lesotho', isoCode: 'LS', isEu: false, availableInPickers: false },
  { id: 111, label: 'Liberia', isoCode: 'LR', isEu: false, availableInPickers: false },
  { id: 112, label: 'Libya', isoCode: 'LY', isEu: false, availableInPickers: false },
  { id: 113, label: 'Liechtenstein', isoCode: 'LI', isEu: false, availableInPickers: false },
  { id: 31, label: 'Lithuania', isoCode: 'LT', isEu: true, availableInPickers: false },
  { id: 218, label: 'Luanda, Rep\u00fablica de Angola', isoCode: 'AO', isEu: false, availableInPickers: true },
  { id: 114, label: 'Luxembourg', isoCode: 'LU', isEu: false, availableInPickers: false },
  { id: 115, label: 'Macao', isoCode: 'MO', isEu: false, availableInPickers: false },
  { id: 117, label: 'Madagascar', isoCode: 'MG', isEu: false, availableInPickers: false },
  { id: 118, label: 'Malawi', isoCode: 'MW', isEu: false, availableInPickers: false },
  { id: 119, label: 'Malaysia', isoCode: 'MY', isEu: false, availableInPickers: false },
  { id: 120, label: 'Maldives', isoCode: 'MV', isEu: false, availableInPickers: false },
  { id: 121, label: 'Mali', isoCode: 'ML', isEu: false, availableInPickers: false },
  { id: 30, label: 'Malta', isoCode: 'MT', isEu: true, availableInPickers: false },
  { id: 122, label: 'Marshall Islands (the)', isoCode: 'MH', isEu: false, availableInPickers: false },
  { id: 123, label: 'Martinique', isoCode: 'MQ', isEu: false, availableInPickers: true },
  { id: 124, label: 'Mauritania', isoCode: 'MR', isEu: false, availableInPickers: false },
  { id: 125, label: 'Mauritius', isoCode: 'MU', isEu: false, availableInPickers: false },
  { id: 126, label: 'Mayotte', isoCode: 'YT', isEu: false, availableInPickers: false },
  { id: 4, label: 'Mexico', isoCode: 'MX', isEu: false, availableInPickers: true, pinIndex: 3 },
  { id: 127, label: 'Micronesia (Federated States of)', isoCode: 'FM', isEu: false, availableInPickers: false },
  { id: 128, label: 'Moldova (the Republic of)', isoCode: 'MD', isEu: false, availableInPickers: true },
  { id: 9, label: 'Monaco', isoCode: 'MC', isEu: false, availableInPickers: true },
  { id: 129, label: 'Mongolia', isoCode: 'MN', isEu: false, availableInPickers: false },
  { id: 130, label: 'Montenegro', isoCode: 'ME', isEu: false, availableInPickers: false },
  { id: 131, label: 'Montserrat', isoCode: 'MS', isEu: false, availableInPickers: true },
  { id: 132, label: 'Morocco', isoCode: 'MA', isEu: false, availableInPickers: false },
  { id: 133, label: 'Mozambique', isoCode: 'MZ', isEu: false, availableInPickers: false },
  { id: 134, label: 'Myanmar', isoCode: 'MM', isEu: false, availableInPickers: false },
  { id: 135, label: 'Namibia', isoCode: 'NA', isEu: false, availableInPickers: false },
  { id: 136, label: 'Nauru', isoCode: 'NR', isEu: false, availableInPickers: false },
  { id: 137, label: 'Nepal', isoCode: 'NP', isEu: false, availableInPickers: false },
  { id: 20, label: 'Netherlands', isoCode: 'NL', isEu: true, availableInPickers: true },
  { id: 138, label: 'New Caledonia', isoCode: 'NC', isEu: false, availableInPickers: false },
  { id: 139, label: 'New Zealand', isoCode: 'NZ', isEu: false, availableInPickers: true },
  { id: 140, label: 'Nicaragua', isoCode: 'NI', isEu: false, availableInPickers: false },
  { id: 141, label: 'Niger (the)', isoCode: 'NE', isEu: false, availableInPickers: false },
  { id: 142, label: 'Nigeria', isoCode: 'NG', isEu: false, availableInPickers: false },
  { id: 143, label: 'Niue', isoCode: 'NU', isEu: false, availableInPickers: false },
  { id: 144, label: 'Norfolk Island', isoCode: 'NF', isEu: false, availableInPickers: false },
  { id: 116, label: 'North Macedonia', isoCode: 'MK', isEu: false, availableInPickers: true },
  { id: 145, label: 'Northern Mariana Islands (the)', isoCode: 'MP', isEu: false, availableInPickers: false },
  { id: 146, label: 'Norway', isoCode: 'NO', isEu: false, availableInPickers: false },
  { id: 147, label: 'Oman', isoCode: 'OM', isEu: false, availableInPickers: false },
  { id: 148, label: 'Pakistan', isoCode: 'PK', isEu: false, availableInPickers: false },
  { id: 149, label: 'Palau', isoCode: 'PW', isEu: false, availableInPickers: false },
  { id: 150, label: 'Palestine, State of', isoCode: 'PS', isEu: false, availableInPickers: false },
  { id: 151, label: 'Panama', isoCode: 'PA', isEu: false, availableInPickers: true },
  { id: 152, label: 'Papua New Guinea', isoCode: 'PG', isEu: false, availableInPickers: false },
  { id: 153, label: 'Paraguay', isoCode: 'PY', isEu: false, availableInPickers: false },
  { id: 154, label: 'Peru', isoCode: 'PE', isEu: false, availableInPickers: true },
  { id: 155, label: 'Philippines (the)', isoCode: 'PH', isEu: false, availableInPickers: false },
  { id: 156, label: 'Pitcairn', isoCode: 'PN', isEu: false, availableInPickers: false },
  { id: 14, label: 'Poland', isoCode: 'PL', isEu: true, availableInPickers: true },
  { id: 26, label: 'Portugal', isoCode: 'PT', isEu: true, availableInPickers: false },
  { id: 157, label: 'Puerto Rico', isoCode: 'PR', isEu: false, availableInPickers: true },
  { id: 158, label: 'Qatar', isoCode: 'QA', isEu: false, availableInPickers: false },
  { id: 15, label: 'Romania', isoCode: 'RO', isEu: true, availableInPickers: true },
  { id: 160, label: 'Russian Federation (the)', isoCode: 'RU', isEu: false, availableInPickers: false },
  { id: 161, label: 'Rwanda', isoCode: 'RW', isEu: false, availableInPickers: false },
  { id: 159, label: 'R\u00e9union', isoCode: 'RE', isEu: false, availableInPickers: false },
  { id: 162, label: 'Saint Barth\u00e9lemy', isoCode: 'BL', isEu: false, availableInPickers: true },
  {
    id: 163,
    label: 'Saint Helena\n Ascension Island\n Tristan da Cunha',
    isoCode: 'SH',
    isEu: false,
    availableInPickers: false
  },
  { id: 164, label: 'Saint Kitts and Nevis', isoCode: 'KN', isEu: false, availableInPickers: true },
  { id: 165, label: 'Saint Lucia', isoCode: 'LC', isEu: false, availableInPickers: true },
  { id: 166, label: 'Saint Martin (French part)', isoCode: 'MF', isEu: false, availableInPickers: true },
  { id: 167, label: 'Saint Pierre and Miquelon', isoCode: 'PM', isEu: false, availableInPickers: false },
  { id: 168, label: 'Saint Vincent and the Grenadines', isoCode: 'VC', isEu: false, availableInPickers: true },
  { id: 169, label: 'Samoa', isoCode: 'WS', isEu: false, availableInPickers: false },
  { id: 170, label: 'San Marino', isoCode: 'SM', isEu: false, availableInPickers: false },
  { id: 171, label: 'Sao Tome and Principe', isoCode: 'ST', isEu: false, availableInPickers: false },
  { id: 172, label: 'Saudi Arabia', isoCode: 'SA', isEu: false, availableInPickers: false },
  { id: 173, label: 'Senegal', isoCode: 'SN', isEu: false, availableInPickers: false },
  { id: 174, label: 'Serbia', isoCode: 'RS', isEu: false, availableInPickers: false },
  { id: 175, label: 'Seychelles', isoCode: 'SC', isEu: false, availableInPickers: false },
  { id: 223, label: 'Shanghai (China)', isoCode: 'SH', isEu: false, availableInPickers: true },
  { id: 176, label: 'Sierra Leone', isoCode: 'SL', isEu: false, availableInPickers: false },
  { id: 177, label: 'Singapore', isoCode: 'SG', isEu: false, availableInPickers: false },
  { id: 178, label: 'Sint Maarten (Dutch part)', isoCode: 'SX', isEu: false, availableInPickers: true },
  { id: 33, label: 'Slovakia', isoCode: 'SK', isEu: true, availableInPickers: true },
  { id: 32, label: 'Slovenia', isoCode: 'SI', isEu: true, availableInPickers: true },
  { id: 179, label: 'Solomon Islands', isoCode: 'SB', isEu: false, availableInPickers: false },
  { id: 180, label: 'Somalia', isoCode: 'SO', isEu: false, availableInPickers: false },
  { id: 181, label: 'South Africa', isoCode: 'ZA', isEu: false, availableInPickers: false },
  {
    id: 182,
    label: 'South Georgia and the South Sandwich Islands',
    isoCode: 'GS',
    isEu: false,
    availableInPickers: false
  },
  { id: 224, label: 'South Korea', isoCode: 'KR', isEu: false, availableInPickers: true },
  { id: 183, label: 'South Sudan', isoCode: 'SS', isEu: false, availableInPickers: false },
  { id: 10, label: 'Spain', isoCode: 'ES', isEu: true, availableInPickers: true },
  { id: 184, label: 'Sri Lanka', isoCode: 'LK', isEu: false, availableInPickers: false },
  { id: 185, label: 'Sudan (the)', isoCode: 'SD', isEu: false, availableInPickers: false },
  { id: 186, label: 'Suriname', isoCode: 'SR', isEu: false, availableInPickers: false },
  { id: 187, label: 'Svalbard\n Jan Mayen', isoCode: 'SJ', isEu: false, availableInPickers: false },
  { id: 16, label: 'Sweden', isoCode: 'SE', isEu: true, availableInPickers: false },
  { id: 7, label: 'Switzerland', isoCode: 'CH', isEu: false, availableInPickers: true },
  { id: 188, label: 'Syrian Arab Republic (the)', isoCode: 'SY', isEu: false, availableInPickers: false },
  { id: 189, label: 'Taiwan (Province of China)', isoCode: 'TW', isEu: false, availableInPickers: true },
  { id: 190, label: 'Tajikistan', isoCode: 'TJ', isEu: false, availableInPickers: false },
  { id: 191, label: 'Tanzania, the United Republic of', isoCode: 'TZ', isEu: false, availableInPickers: false },
  { id: 192, label: 'Thailand', isoCode: 'TH', isEu: false, availableInPickers: false },
  { id: 193, label: 'Timor-Leste', isoCode: 'TL', isEu: false, availableInPickers: false },
  { id: 194, label: 'Togo', isoCode: 'TG', isEu: false, availableInPickers: false },
  { id: 195, label: 'Tokelau', isoCode: 'TK', isEu: false, availableInPickers: false },
  { id: 196, label: 'Tonga', isoCode: 'TO', isEu: false, availableInPickers: false },
  { id: 197, label: 'Trinidad and Tobago', isoCode: 'TT', isEu: false, availableInPickers: true },
  { id: 198, label: 'Tunisia', isoCode: 'TN', isEu: false, availableInPickers: false },
  { id: 5, label: 'Turkey', isoCode: 'TR', isEu: false, availableInPickers: true },
  { id: 199, label: 'Turkmenistan', isoCode: 'TM', isEu: false, availableInPickers: false },
  { id: 200, label: 'Turks and Caicos Islands (the)', isoCode: 'TC', isEu: false, availableInPickers: true },
  { id: 201, label: 'Tuvalu', isoCode: 'TV', isEu: false, availableInPickers: false },
  { id: 202, label: 'Uganda', isoCode: 'UG', isEu: false, availableInPickers: false },
  { id: 203, label: 'Ukraine', isoCode: 'UA', isEu: false, availableInPickers: true },
  { id: 204, label: 'United Arab Emirates (the)', isoCode: 'AE', isEu: false, availableInPickers: false },
  { id: 11, label: 'United Kingdom', isoCode: 'UK', isEu: true, availableInPickers: true },
  {
    id: 205,
    label: 'United States Minor Outlying Islands (the)',
    isoCode: 'UM',
    isEu: false,
    availableInPickers: false
  },
  { id: 206, label: 'Uruguay', isoCode: 'UY', isEu: false, availableInPickers: false },
  { id: 207, label: 'Uzbekistan', isoCode: 'UZ', isEu: false, availableInPickers: false },
  { id: 208, label: 'Vanuatu', isoCode: 'VU', isEu: false, availableInPickers: false },
  { id: 209, label: 'Venezuela (Bolivarian Republic of)', isoCode: 'VE', isEu: false, availableInPickers: false },
  { id: 210, label: 'Viet Nam', isoCode: 'VN', isEu: false, availableInPickers: true },
  { id: 211, label: 'Virgin Islands (British)', isoCode: 'VG', isEu: false, availableInPickers: true },
  { id: 212, label: 'Virgin Islands (U.S.)', isoCode: 'VI', isEu: false, availableInPickers: true },
  { id: 213, label: 'Wallis and Futuna', isoCode: 'WF', isEu: false, availableInPickers: false },
  { id: 214, label: 'Western Sahara', isoCode: 'EH', isEu: false, availableInPickers: false },
  { id: 215, label: 'Yemen', isoCode: 'YE', isEu: false, availableInPickers: false },
  { id: 216, label: 'Zambia', isoCode: 'ZM', isEu: false, availableInPickers: false },
  { id: 217, label: 'Zimbabwe', isoCode: 'ZW', isEu: false, availableInPickers: false }
];

// Picker-visible countries. Order is left to consumers (e.g. react-phone-number-input
// re-sorts what it receives via `countries` and `countryOptionsOrder`).
export function getCountriesForPicker() {
  return countries.filter(c => c.availableInPickers);
}

// Countries flagged with pinIndex, sorted ascending. Used to build "pinned at top"
// ordering lists for pickers that support it.
export function getPinnedCountries() {
  return countries
    .filter(c => c.pinIndex !== undefined)
    .sort((a, b) => a.pinIndex - b.pinIndex);
}

export function isEuCountry(countryId) {
  const country = countries.find(c => c.id === Number(countryId));
  return country ? country.isEu : false;
}

export function getUnitedStatesId() {
  return 1;
}

export function getUnitedKingdomId() {
  return 11;
}
